import { useEffect } from 'react';
import { HeaderFooterEvents, CmsBlocksEvents, CommonEvents, WebComponents, StepEvents } from './constants';
import { setAllowNavigation, setVisPersonvelger } from '../hn-user';
export var SessionTimeoutAction;
(function (SessionTimeoutAction) {
    SessionTimeoutAction[SessionTimeoutAction["Default"] = 0] = "Default";
    SessionTimeoutAction[SessionTimeoutAction["RequestExtension"] = 1] = "RequestExtension";
    SessionTimeoutAction[SessionTimeoutAction["RequestLogout"] = 2] = "RequestLogout";
})(SessionTimeoutAction || (SessionTimeoutAction = {}));
/**
 * Legger til CustomEvent i window.HN.Events. window.HN.Events leses av webkomponenter
 * ved mount for å fange opp events som ble sendt før webkomponenten ble mountet.
 *
 * @param selector Navn på webkomponent
 * @param event CustomEvent som skal legges til i HN.Events
 */
const addToHnEvents = (selector, event) => {
    window.HN = window.HN || {};
    window.HN.FrontendEvents = window.HN.FrontendEvents || [];
    window.HN.FrontendEvents.push({ selector, event });
};
const dispatchCustomEvent = (selector, eventType, detail) => {
    const element = document.querySelector(selector);
    const event = new CustomEvent(eventType, {
        cancelable: true,
        detail,
    });
    if (element?.dispatchEvent) {
        element.dispatchEvent(event);
    }
    addToHnEvents(selector, event);
};
export const HNeventSetFirstTimeLogin = (isFirstTime = true) => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.setfirsttimelogin, { firstTimeLogin: isFirstTime });
export const HNeventSetAnonymousHeader = (isAnonymous = true) => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.setanonymousheader, { anonymousHeader: isAnonymous });
export const HNeventSetHiddenHeader = (isHidden = true) => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.sethiddenheader, { hiddenHeader: isHidden });
export const HNeventSetHiddenFooter = (isHidden = true) => dispatchCustomEvent('hn-webcomp-footer', HeaderFooterEvents.sethiddenfooter, {
    hiddenFooter: isHidden,
});
export const HNeventSetNoMarginFooter = (noMargin = true) => dispatchCustomEvent('hn-webcomp-footer', HeaderFooterEvents.setnomarginfooter, {
    noMarginFooter: noMargin,
});
export const HNeventRefreshVarslinger = () => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.refreshvarslinger, {});
export const HNeventSetDriftsmeldingPath = (path) => dispatchCustomEvent('hn-webcomp-driftspanel', HeaderFooterEvents.setdriftsmeldingpath, { path });
export const HNeventSetOnShowSignoutbox = (fn) => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.setonshowsignoutbox, { onShowSignOutBox: fn });
export const HNeventSetUserLoading = (userLoading) => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.setuserloading, { userLoading });
export const HNeventSoonAutoSignOut = () => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.soonautosignout, {});
export const HNeventShowAppInvitation = (onAppOpen, onWebLogin, onClose) => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.showappinvitation, { onAppOpen, onWebLogin, onClose });
export const HNeventSetRedirectTo = (redirectTo) => dispatchCustomEvent('hn-webcomp-personvelger', HeaderFooterEvents.setredirectto, { redirectTo });
export const HNeventSetRedirectToUrlAfterLogin = (redirectToUrlAfterLogin) => dispatchCustomEvent('hn-webcomp-personvelger', HeaderFooterEvents.setredirecttourlafterlogin, {
    redirectToUrlAfterLogin,
});
/**
 * Bestemmer hvilken URL man skal redirecte til etter å klikket på Logg inn-knappen i header
 *
 * @param redirectUrl URL som skal redirectes til, inkludert domene, f.eks. https://tjenester.helsenorge.no/skjemautfyller/HSO_QoR15NO?lang=nb-NO
 */
export const HNeventSetLoginRedirectUrl = (redirectUrl) => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.setloginredirecturl, { redirectUrl });
/**
 * Bestemmer hvilken URL man skal redirecte til etter å byttet representasjon via personvelgeren i header
 *
 * @param redirectUrl URL som skal redirectes til, inkludert domene, f.eks. https://tjenester.helsenorge.no/skjemautfyller/HSO_QoR15NO?lang=nb-NO
 */
export const HNeventSetPersonvelgerRedirectUrl = (redirectUrl) => dispatchCustomEvent('hn-webcomp-header', HeaderFooterEvents.setpersonvelgerredirecturl, { redirectUrl });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HNeventSetSurveys = (surveys) => dispatchCustomEvent('hn-webcomp-footer', HeaderFooterEvents.setsurveys, { surveys });
export const HNeventSetFooterData = (data) => dispatchCustomEvent('hn-webcomp-footer', HeaderFooterEvents.setfooterdata, data);
export const HNeventSetVisPersonvelger = (visPersonvelger) => {
    setVisPersonvelger(visPersonvelger);
    window.dispatchEvent(new CustomEvent(HeaderFooterEvents.setvispersonvelger, {
        detail: { visPersonvelger },
    }));
};
/**
 * Dispatcher event før forsøk på å navigasjon vekk fra siden. Brukes i av webkomponenter (f.eks. header-footer),
 * slik at de kan trigge advarsel i PendingChanges om at navigasjon er i ferd med å skje.
 *
 * @returns true dersom bruker godtar navigasjon bort fra siden
 */
export const HNeventAttemptNavigation = () => {
    return window.dispatchEvent(new CustomEvent(CommonEvents.attemptNavigation, {
        cancelable: true,
    }));
};
/**
 * Lytter etter forsøk på navigasjon vekk fra siden, og viser dialog med advarsel før man eventuelt får gå videre.
 *
 * @param message Beskjed til brukeren
 * @param hasChanges Returnerer true dersom navigasjon skal blokkeres
 */
export const useAttemptNavigationEvent = (message, hasChanges) => useEventListener(CommonEvents.attemptNavigation, window, (event) => {
    if (hasChanges()) {
        const confirmLeave = window.confirm(message);
        if (!confirmLeave) {
            event.preventDefault();
            return;
        }
        else {
            setAllowNavigation(true);
        }
    }
});
export const HNeventSetHiddenPromopanel = (isHidden) => dispatchCustomEvent(WebComponents.Promopanel, CmsBlocksEvents.setHiddenPromopanel, { hiddenPromopanel: isHidden });
export const HNeventIsMicroFrontendMounted = (webcomponentName) => {
    const webcomponent = document.querySelector(webcomponentName);
    if (webcomponent?.dispatchEvent) {
        webcomponent.dispatchEvent(new CustomEvent(CommonEvents.isMounted));
    }
};
export const useEventListener = (event, element, handler, passive = false) => {
    useEffect(() => {
        if (element) {
            element.addEventListener(event, handler, passive);
        }
        return function cleanup() {
            if (element) {
                element.removeEventListener(event, handler);
            }
        };
    });
};
export const HNeventNavigateStep = (stepId, detail) => dispatchCustomEvent(`#${stepId}`, StepEvents.Navigate, detail);
export const HNeventSendFromWebComponent = (stepId, detail) => dispatchCustomEvent(`#${stepId}`, StepEvents.SendFromWebComponent, detail);
/**
 * Global event ved bytte av språk
 * @param language Nytt språk
 * @param options Brukes til å begrense antall oppdateringer
 */
export const HNeventSetLanguage = (language, options) => {
    document.dispatchEvent(new CustomEvent(CommonEvents.setLanguage, { detail: { language, options } }));
};
/**
 * Brukes for å signalisere at en ny microweb har blitt instansiert på siden.
 */
export const HNeventMicrowebMounted = () => {
    document.dispatchEvent(new CustomEvent(CommonEvents.microwebMounted));
};
/**
 * Brukes for å sende data alle microweber (som bruker MicrowebRoot-komponenten) som er instansiert på siden
 * @param detail Data som skal sendes
 */
export const HNeventSendToMicrowebRoot = (detail) => {
    document.dispatchEvent(new CustomEvent(CommonEvents.sendToMicrowebRoot, { detail }));
};
